import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { MatterTitleSkeleton } from '@/components/ui/skeletons/MatterSkeleton';
import { useFilevineIngestPrompt } from '@/hooks/useFilevineIngestPrompt';
import { useGetMatterDetailsQuery } from '@/services/api';

import { MatterTitleDisplay } from './MatterTitleDisplay';

const MatterTitleSection = ({
  matterData,
}: {
  matterData: any | undefined;
}) => {
  const navigate = useNavigate();

  const handleEditClick = () => {
    if (matterData?.id) {
      navigate(`/matters/${matterData.id}/edit`);
    }
  };

  // Display view uses MatterTitleDisplay component
  return (
    <MatterTitleDisplay
      matterData={matterData}
      name={matterData?.name}
      status={matterData?.status}
      type={matterData?.matter_type}
      dateOfLoss={matterData?.date_of_loss}
      sol={matterData?.statute_of_limitations_date}
      city={matterData?.city}
      state={matterData?.state}
      contactClientDirectly={matterData?.contact_client_directly}
      onEditClick={handleEditClick}
    />
  );
};

const MatterTitle: React.FC = () => {
  const { matter_id } = useParams<{ matter_id: string }>();

  // Prompt to ingest from Filevine when CMS URL is added
  useFilevineIngestPrompt(matter_id || '');

  const { data: selectedMatterData, isLoading: selectedMatterLoading } =
    useGetMatterDetailsQuery(matter_id || '', {
      skip: !matter_id,
    });

  if (selectedMatterLoading) {
    return <MatterTitleSkeleton />;
  }

  return <MatterTitleSection matterData={selectedMatterData} />;
};

export default MatterTitle;
